'use client'
import { useContext } from 'react'
import { ContrastContext } from '../../context/ContrastContext'
import { useTranslation } from '../../context/ConfigContext'
import clsx from 'clsx'

export function ContrastSwitch() {
  const { contrast, setContrast } = useContext(ContrastContext)
  const t = useTranslation()
  const ns = 'headerv2'
  return (
    <label
      htmlFor={`${ns}-contrast-switch`}
      className={clsx(
        'flex items-center gap-4 select-none group/btn cursor-pointer text-p1',
        'border-none bg-transparent',
      )}>
      <input
        role='switch'
        type='checkbox'
        className='peer filter fixed -start-full -z-50'
        name='contrast-switch'
        id={`${ns}-contrast-switch`}
        checked={contrast}
        onChange={() => {
          setContrast(!contrast)
        }}
      />
      <div className='rounded-full w-8 h-4 bg-black/20 peer-checked:bg-black peer-checked:ps-4 duration-300 peer-focus:outline ms-0'>
        <div className='border bg-white block size-4 rounded-full'></div>
      </div>
      <span className='text-sm text-black'>{t('header-contrast-label')}</span>
    </label>
  )
}
